module.exports = __webpack_public_path__ + "img/charterscanners_logo_old.003be4cf.png";